
import { combineReducers } from 'redux';
import authReducer from "./auth";
import usersReducer from "./users";
import countriesReducer from "./countries";
import contactsReducer from "./contacts";
import installersReducer from "./installers";
import floorsReducer from "./floors";
import floorCategoriesReducer from "./floor-categories";
import floorTypesReducer from "./floor-types";
import teamMembersReducer from "./team-members";
import videosReducer from "./videos";
import colorsReducer from "./colors";
import meReducer from "./me";
import reviewsReducer from "./reviews";
import getValidationErrorsReducer from "./validationErrors";


const validationErrorsReducer = getValidationErrorsReducer(
    {
        phase1: { "USER": "users", "AUTH": "auth", "COUNTR": "countries" },
    }
)

export default combineReducers({
    installers: installersReducer,
    me: meReducer,
    reviews: reviewsReducer,
    auth: authReducer,
    users: usersReducer,
    countries: countriesReducer,
    contacts: contactsReducer,
    floors: floorsReducer,
    floor_categories: floorCategoriesReducer,
    floor_types: floorTypesReducer,
    team_members: teamMembersReducer,
    videos: videosReducer,
    colors: colorsReducer,
    validationErrors: validationErrorsReducer
});